import React from 'react'

export const vuHQLink = linkTitle => {
  return (
    <a className="txt-link" href="https://www.vu.edu.au/contact-us/vuhq-student-service-centres" target={'_blank'}>
      {linkTitle}
    </a>
  )
}

export const helpVuCourseLink = (courseCode = '', courseLinkText = '', className = '') => {
  let linkHref = `https://www.vu.edu.au/courses/${courseCode}`

  return React.createElement('a', { href: linkHref, target: '_blank', class: className }, courseLinkText)
}
